import { Card, Col, Row } from 'react-bootstrap'
import { FaCheckCircle } from 'react-icons/fa'
import styles from '~/styles/_pricing.module.scss'

type TargetUser = {
  name: string
  appeal: string
  imageURL: string
  useCases: string[]
}

const TARGET_USERS: TargetUser[] = [
  {
    name: '数学が好きな学生',
    appeal: '学びの整理や資料の作成及び共有をより円滑に',
    imageURL: '/images/pricing_learning_sketching.svg',
    useCases: [
      '自分の学びや授業の内容を非公開でWebに記録',
      'Mathlogの記事や本をLaTeX形式で出力して、ゼミの資料や提出物の形式に簡単に変換',
      '先生や数学好きな仲間と資料をリアルタイムに共同編集',
    ],
  },
  {
    name: '数学コミュニティの所属者',
    appeal: 'コミュニティで出会った仲間とのコラボレーションがより円滑に',
    imageURL: '/images/pricing_teaching.svg',
    useCases: [
      'コミュニティで話題になった内容を共同で記事や本にして投稿',
      'コミュニティの所属者限定で記事や本を共有',
    ],
  },
  {
    name: '数学の教員や塾講師',
    appeal: '教材の作成と生徒への共有が容易に',
    imageURL: '/images/pricing_meeting.svg',
    useCases: [
      'Mathlogで作成した教材をLaTeX形式で簡単に出力',
      '生徒や関係者に限定して教材をWebで公開',
    ],
  },
  {
    name: '数学者',
    appeal: '日々の思考の整理と研究のメモに',
    imageURL: '/images/pricing_mathematics.svg',
    useCases: [
      'LaTeXエクスポートで学術誌への投稿準備が容易に',
      'リアルタイム共同編集で共同研究者との連携を快適に',
    ],
  },
]

export const TargetUsersSection = () => (
  <section
    key="feature"
    className={`${styles['bg-gray']} py-7 px-6 ${styles.feature}`}
    style={{ padding: '0px 32px' }}
  >
    <div className="mx-auto" style={{ maxWidth: 980 }}>
      <h2 className={`${styles.h2} mb-5`}>こんな方におすすめ</h2>
      <Row xs={1} className="g-4 m-0">
        {TARGET_USERS.map((targetUser) => (
          <Col key={targetUser.name} className="m-0">
            <div>
              <hr className="my-6 mx-n3" />
              <Card className="d-flex flex-column flex-sm-row justify-content-center align-items-center bg-transparent border-0 mx-auto">
                <Row
                  xs={1}
                  sm={2}
                  className="w-100 m-0"
                  style={{ minHeight: 170 }}
                >
                  <Col
                    sm={5}
                    className="text-center p-0 mb-5 mb-sm-0 align-self-center"
                  >
                    <Card.Img
                      className="w-100"
                      src={targetUser.imageURL}
                      style={{ maxHeight: 140 }}
                    />
                  </Col>
                  <Col sm={7} className="d-flex p-0 align-self-center">
                    <Card.Body className="flex-grow-1 p-0 bg-transparent">
                      <Card.Title
                        className={`${styles['feature-name']} mb-0`}
                        as="h3"
                      >
                        {targetUser.name}
                      </Card.Title>
                      <Card.Text className="text-muted small mb-3">
                        {targetUser.appeal}
                      </Card.Text>
                      <ul
                        className="small mb-0 ps-0"
                        style={{
                          listStyle: 'none',
                          lineHeight: '1.25rem',
                        }}
                      >
                        {targetUser.useCases.map((useCase) => (
                          <li
                            className="position-relative ps-5 py-1"
                            key={useCase}
                          >
                            <span
                              className="position-absolute start-0 text-center"
                              style={{ color: '#2c90d3' }}
                            >
                              <FaCheckCircle />
                            </span>
                            {useCase}
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </div>
          </Col>
        ))}
        <Col className="m-0">
          <hr className="mt-6 mx-n3" />
        </Col>
      </Row>
    </div>
  </section>
)
